import { isSberUzbekistan } from '@p2p/entities/qrInvoice/sber';
import { TGetOrderResponse } from '@p2p/services';
import { getNestedValue } from '@p2p/shared/functions';

import { infoItems, sberUzbekistanInfoItems } from './AccountNumberInfoItems.constants';

export type RequisiteRow = {
  label: string;
  value: string;
  canCopy: boolean;
};

/**
 * Поля блока «Оплата по номеру счёта/телефона» с уже подставленными значениями; пустые не попадают.
 * P2P-3116: вынесено из AccountNumberInfoItems - тот же набор полей на странице alfa_page.
 */
export const getRequisiteRows = (order: TGetOrderResponse, randomId: string): RequisiteRow[] => {
  // P2P-2739: у Phoneix (ссылка на оплату order.invoice_url) реквизит — SBP по
  // номеру телефона, а не расчётный счёт: показываем телефон/банк/получателя,
  // тот же набор полей, что и у сберовских заявок на банки Узбекистана.
  const isPhoneRequisite = isSberUzbekistan(order) || Boolean(order.invoice_url);
  const data = isPhoneRequisite ? sberUzbekistanInfoItems : infoItems;

  return data.flatMap((item) => {
    let value = getNestedValue(order.requisite, item.field);

    if (item.field === 'purpose') {
      // Для IronPay (qr_invoice) показываем персональное назначение из ордера
      // целиком; иначе — назначение реквизита со случайным номером.
      if (order.requisite.qr_invoice && order.purpose) {
        value = order.purpose;
      } else if (value) {
        value = `${value} #${randomId}`;
      }
    }

    return value ? [{ label: item.label, value, canCopy: item.isCopy }] : [];
  });
};
